module.exports = __webpack_public_path__ + "img/gallery-svgrepo-com.0837e835.svg";